<template>
  <AppContainer id="app-credit-cards">
    <div class="row">
      <div class="col">
        <button @click.prevent="handleAddCardPressed" class="btn btn-link text-primary" id="add-card-btn">
          <i class="fas fa-plus-circle me-1"></i> Adicionar
        </button>
      </div>
      <div class="col-auto">
      </div>
    </div>
    <AppLoading :loading="loading">
      <EmptyState v-if="creditCards.length == 0" />
      <template v-else>
        <CardListItem v-for="item in creditCards" :card="item"
          :selected="currentPaymentMethod?.card_info?.id == item.id" @onRemove="handleRemoveCard(item)"
          @onSelect="handleSelectCard(item)" />
      </template>
    </AppLoading>
    <ConfirmModal
      title="Remover cartão"
      :message="confirmMessage"
      confirmText="Remover"
      @onAction="handleConfirmAction"
    />
  </AppContainer>
</template>

<script lang="ts" setup>
import CardListItem from '@/components/CardListItem.vue';
import ConfirmModal from '@/components/Modals/ConfirmModal.vue';
import { EOffcanvasPage } from '@/components/Offcanvas/canvas.pages';
import useOffCanvas from '@/components/Offcanvas/useOffCanvas';
import useCards from '@/composables/useCards';
import usePayment from '@/composables/usePayment';
import { EPaymentType, EModal } from '@/enums';
import { ICardInfo } from '@/interfaces';
import { onMounted, ref } from 'vue';
import useModals from '@/components/Modals/useModals';
import { ConfirmModalResponse } from '@/components/Modals/modals.types';

const { creditCards, getCards, removeCard, loading } = useCards()
const { currentPaymentMethod, savePaymentMethod } = usePayment()
const { navigateCanvas, canvasBackPressed } = useOffCanvas()
const { toggleModal } = useModals()

const confirmMessage = ref('')
const cardToRemove = ref<ICardInfo | null>(null)

onMounted(() => {
  loading.value = true
  getCards()
})

const handleSelectCard = (item: ICardInfo) => {
  savePaymentMethod({
    payment_type: EPaymentType.credit_card,
    card_info: item
  })
  canvasBackPressed
}
const handleRemoveCard = (item: ICardInfo) => {
  confirmMessage.value = `Deseja remover o cartão final ${item.card_last_digits}?`
  cardToRemove.value = item
  toggleModal(EModal.confirm)
}
const handleConfirmAction = (action: ConfirmModalResponse) => {
  if (action === 'confirm' && cardToRemove.value) {
    removeCard(cardToRemove.value)
  }
  cardToRemove.value = null
}
const handleAddCardPressed = () => {
  navigateCanvas(EOffcanvasPage.add_card)
}
</script>
